export default "__VITE_ASSET__CeYD7Y9W__"